module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/1b06785a82e67aa92a0c3a2b9ef9f0b5.png";